import React from 'react';
import './InfoBox.css';

interface InfoBoxProps {
  text: string;
  onClose: () => void;
}

const InfoBox: React.FC<InfoBoxProps> = ({ text, onClose }) => {
  return (
    <div className="info-box">
      <p>{text}</p>
      <button onClick={onClose} className="info-box-close">
        &times;
      </button>
    </div>
  );
};

export default InfoBox;
